import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Sidebar from './Sidebar'; // Import Sidebar
import MyListings from './MyListings'; // Import the MyListings component
import MyReservations from './MyReservations'; // Import the MyListings component
import MyBookings from './MyBookings';
import MyBackAccountDetails from './MyBankAccountDetails'


const ProfileContainer = styled.div`
  display: flex;
  padding: 20px;
  justify-content: flex-start;
`;

const ContentArea = styled.div`
  width: 100%;
  margin-left: 20px; /* Add margin to separate from sidebar */
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 20px;
`;

const ErrorMessage = styled.p`
  color: red;
`;

const UserProfile = () => {
  const [userDetails, setUserDetails] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('profile'); // Manage active tab

  useEffect(() => {
    const token = localStorage.getItem('jwt_token');

    if (!token) {
      setError('You are not logged in. Please log in to view your profile.');
      setLoading(false);
      return;
    }

    fetch(`${process.env.REACT_APP_API_BASE_URL}/me`, {
    // fetch('http://localhost:8000/me', {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch user profile.');
        }
        return response.json();
      })
      .then((data) => {
        setUserDetails(data);
        setLoading(false);
      })
      .catch((error) => {
        setError(error.message);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <ProfileContainer><p>Loading...</p></ProfileContainer>;
  }

  if (error) {
    return (
      <ProfileContainer>
        <ContentArea>
          <ErrorMessage>{error}</ErrorMessage>
        </ContentArea>
      </ProfileContainer>
    );
  }

  // Handle what content to display based on the active tab
  const renderContent = () => {
    switch (activeTab) {
      case 'listings':
        return <MyListings authToken={localStorage.getItem('jwt_token')} />;
      case 'reservations':
        return <MyReservations authToken={localStorage.getItem('jwt_token')} />;
      case 'bookings':
        return <MyBookings authToken={localStorage.getItem('jwt_token')} />;
      case 'bankAccount':
        return <MyBackAccountDetails authToken={localStorage.getItem('jwt_token')} />;
      default:
        return (
          <>
            <Title>User Profile</Title>
            <p>Email: {userDetails?.email}</p>
            <p>Name: {userDetails?.name}</p>
            <p>Member since: {new Date(userDetails?.member_since).toLocaleDateString()}</p>
            <p>Rating: {userDetails?.rating || 'N/A'}</p>
          </>
        );
    }
  };

  return (
    <ProfileContainer>
      {/* Sidebar with user details and tab switch handler */}
      <Sidebar user={userDetails} setActiveTab={setActiveTab} />
      
      {/* Content Area */}
      <ContentArea>
        {renderContent()}
      </ContentArea>
    </ProfileContainer>
  );
};

export default UserProfile;
